<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: #bebebe;
}

header {
  /* height: 75px; */
  background: #652f8f;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}

sidebar {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 70;
  top: 0;
  left: 0;
  background-color: #652f8f;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}

.show-sidebar {
  width: 270px !important;
}

.main-content {
  transition: margin-left 0.5s;
  margin-top: 80px;
}
.main-content-margin {
  margin-left: 275px;
}

@media only screen and (max-width: 600px) {
  .main-content-margin {
    margin-left: 0px;
  }
}
</style>

<style>
@import './assets/css/partner_default.css';

.page-heading {
  /* padding-top: 15px; */
}
.page-heading::after {
  content: '';
  clear: both;
  display: table;
}
.page-heading h2 {
  float: left;
  font-size: 26px;
  font-weight: 600;
  margin: 0 !important;
  line-height: 38px;
}
.page-heading a,
.page-heading button {
  float: right;
}
</style>
